module.exports = __webpack_public_path__ + "img/Wp_2001.8ec6f780.png";